<template>
  <div class="exWarehouse">
    <div class="init_view">
      <div class="phoneNo wrap"><span class="text">手机号后四位：</span>
        <div class="num_cell">
          <span class="cell">6</span> 
          <span class="cell">6</span> 
          <span class="cell">1</span> 
          <span class="cell">0</span>
        </div>
      </div>
      <div class="takeCode wrap"><span class="text">取件码：</span>
        <div class="num_cell">
          <span class="cell">1</span>
          <span class="cell">0</span>
          <span class="cell">0</span>
          <span class="cell">8</span>
          <span class="cell">6</span>
          <span class="cell">6</span>
        </div>
      </div>
      <div class="confirmBtn btn">确认</div>
    </div>
  </div>
</template>

<script>
import "../../../../static/CEsite/css/common.less"
export default {
  data() {
    return {

    }
  },
  created() {
    this.actionType = this.$route.query.actionType;
    console.warn('出库页actionType：',this.actionType);
  },
  methods: {

  }
}
</script>

<style lang="less">
.exWarehouse{
.init_view {
  width: 60%;
  font-size: 0.68rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  .wrap {
    width: 100%;
    display: flex;
    // justify-content: space-between;
    margin-bottom: 0.8rem;
    span.text {
      width: 42%;
    }
    .num_cell {
      .cell {
        display: inline-block;
        width: 0.86rem;
        height: 0.86rem;
        border: 1px solid #333;
        text-align: center;
        line-height: 0.86rem;
      }
    }
  }
  .confirmBtn {
    width: 30%;
    padding: 0.2rem 0;
    margin-top: 0.5rem;
    font-size: 0.5rem;
    letter-spacing: 0.1rem;
  }
}
}
</style>


// WEBPACK FOOTER //
// src/components/CEsite/EX-warehouse/index.vue